<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="公司名称">
                  <el-input  v-model="queryForm.companyName"></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                  <el-input  v-model="queryForm.contact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                  <el-input  v-model="queryForm.telephone"></el-input>
              </el-form-item>
              <el-form-item label="提醒类型">
                  <el-select placeholder="请选择类型" clearable style="width: 177px"
                      size="small" v-model="queryForm.reminderType">
                      <el-option v-for='(item, index) in propertyReminderType' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getPropertyCompanyList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addPropertyCompany"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editPropertyCompany(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deletePropertyCompany(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <!-- <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportPropertyCompanyList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span> -->
        <span
          class="icon-box"
          @click="refreshPropertyCompanyList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="propertyCompanyList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyName"
        label="公司名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contact"
        label="联系人"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="telephone"
        label="联系电话"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkPropertyCompany(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editPropertyCompany(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deletePropertyCompany(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="propertyCompanyStates[propertyCompanyState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="propertyCompany"
          ref="propertyCompanyForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="公司名称"
            prop="companyName"
          >
            <el-input
              size="small"
              v-model="propertyCompany.companyName"
              :disabled="propertyCompanyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="contact"
          >
            <el-input
              size="small"
              v-model="propertyCompany.contact"
              :disabled="propertyCompanyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="telephone"
          >
            <el-input
              size="small"
              v-model="propertyCompany.telephone"
              :disabled="propertyCompanyState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="propertyCompanyState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetPropertyCompanyList();
                    this.getPropertyCompanyList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetPropertyCompanyList();
                    this.getPropertyCompanyList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     companyName: '', //公司名称
                     contact: '', //联系人
                     telephone: '', //电话
                     reminderType:''
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                propertyCompanyState: 'add',
                propertyCompanyStates: {
                    add: '新建公司',
                    check: '查看公司',
                    edit: '修改公司'
                },

                multipleSelection: [],
                propertyCompanyList: [],
                propertyCompany: {
                    companyName: '', //公司名称
                    contact: '', //联系人
                    telephone: '', //电话
                    createTime: '', //
                    updateTime:''
                },
                btnLoading: false,
                propertyReminderType:[],
                rules: {
                    companyName: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }],
                    contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                    telephone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            this.getPropertyCompanyList();
            this.getpropertyReminderTypeList()
        },
        methods: {
            // 提醒
            getpropertyReminderTypeList() {
              get('/mpp/utils/getEnum', {
                  enumType: 'property_reminder_type',
                }).then((res) => {
                  if (res.success) {
                    // console.log(res.enumList)
                    this.propertyReminderType = res.enumList
                  }
                })
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetPropertyCompanyList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.propertyCompanyList = [];
            },
            resetDialog() {
                this.propertyCompanyState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      companyName: '', //公司名称
                      contact: '', //联系人
                      telephone: '', //电话
                      reminderType:''
                };
                this.getPropertyCompanyList();
            },
            closeDialog() {
                this.showDialog = false
                this.propertyCompany = {
                      companyName: '', //公司名称
                      contact: '', //联系人
                      telephone: '', //电话
                      createTime: '', //
                      updateTime:''
                };
            },
            submitForm() {
                if (this.propertyCompanyState == 'add') {
                    this.$refs.propertyCompanyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/property/company/add`,{ ...this.propertyCompany }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetPropertyCompanyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.propertyCompanyState == 'edit') {
                    this.$refs.propertyCompanyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/property/company/edit`,{ ...this.propertyCompany }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetPropertyCompanyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addPropertyCompany() {
                this.showDialog = true;
                this.propertyCompanyState = 'add';
            },
            checkPropertyCompany(propertyCompanyId) {
                console.log(propertyCompanyId);
                this.currentPropertyCompanyId = propertyCompanyId;

                this.getPropertyCompanyById();
                this.showDialog = true;
                this.propertyCompanyState = 'check';
            },
            editPropertyCompany(propertyCompanyId) {
                console.log('propertyCompany', propertyCompanyId);
                if (propertyCompanyId) {
                    this.currentPropertyCompanyId = propertyCompanyId;
                    this.getPropertyCompanyById();
                } else {
                    this.propertyCompany = { ...this.propertyCompany, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.propertyCompanyState = 'edit';
            },
            deletePropertyCompany(propertyCompanyId) {
                let ids = '';
                if (propertyCompanyId) {
                    ids = propertyCompanyId;
                } else {
                    ids = this.multipleSelection.map((propertyCompany) => propertyCompany.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/property/company/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetPropertyCompanyList();
                                this.getPropertyCompanyList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshPropertyCompanyList() {
                this.resetPropertyCompanyList();
                this.getPropertyCompanyList();
            },
            getPropertyCompanyList(query = {}) {
                this.loading = true;
                get(`/property/company/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.propertyCompanyList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getPropertyCompanyById() {
                get(`/property/company/get`,{ id: this.currentPropertyCompanyId }).then((res) =>{
                    if(res.success){
                      this.propertyCompany = { ...this.propertyCompany, ...res.propertyCompany };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportPropertyCompanyList() {
                //this.btnLoading = true;
                exprotExcel(`/property/company/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/property/company/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/property/company/importData`,formData);
              this.refreshPropertyCompanyList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getPropertyCompanyList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getPropertyCompanyList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>